/* =============================================================================
   Dwellow grid widget, ENGINE (vanilla JS, no dependencies)
   -----------------------------------------------------------------------------
   Renders the three views from DW_GRID_DATA and wires the tabs. Charts are
   hand-rolled inline SVG, (re)drawn to the widget's OWN pixel width so labels
   stay crisp from 320→760px. Icons are inline SVG (outline, ~1.8px stroke ,
   the Lucide feel used across Dwellow). No external assets of any kind.

     DwellowGrid.mount(el, { direction:'warm'|'compact'|'playful', view:'now', data })

   VENDORED from the Dwellow Design System (Design System > grid-widget). Kept
   byte-identical to the source EXCEPT three integration edits, marked
   "[dwellow-integration]": the IIFE is unwrapped into an ES module, the data
   source `D` is settable (via opts.data / setData) instead of a fixed global,
   and DwellowGrid is exported. Live-data mapping lives in buildData.js.
   ============================================================================ */

// [dwellow-integration] was: (function () { 'use strict'; var D = window.DW_GRID_DATA;
var D = (typeof window !== 'undefined' && window.DW_GRID_DATA) || {};
var uid = 0;

/* ---- inline SVG icons (outline) ----------------------------------------- */
var P = {
  leaf:     '<path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.5 19 2c1 2 2 4.2 2 8 0 5.5-4.8 10-10 10Z"/><path d="M2 21c0-3 1.9-5.4 5-6"/>',
  sun:      '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/>',
  wind:     '<path d="M17.7 7.7a2.5 2.5 0 1 1 1.8 4.3H3M9.6 4.6A2 2 0 1 1 11 8H3m8.5 12a2.5 2.5 0 1 0 2.5-4H3"/>',
  droplet:  '<path d="M12 3s6 5.7 6 10.5A6 6 0 0 1 6 13.5C6 8.7 12 3 12 3Z"/>',
  atom:     '<circle cx="12" cy="12" r="1.6"/><ellipse cx="12" cy="12" rx="10" ry="4.4"/><ellipse cx="12" cy="12" rx="10" ry="4.4" transform="rotate(60 12 12)"/><ellipse cx="12" cy="12" rx="10" ry="4.4" transform="rotate(120 12 12)"/>',
  sprout:   '<path d="M7 20h10M12 20v-9"/><path d="M12 11C12 7.5 9.3 5 6 5c0 3.5 2.7 6 6 6Z"/><path d="M12 11c0-3 2.7-5.5 6-5.5 0 3-2.7 5.5-6 5.5Z"/>',
  plug:     '<path d="M9 2v6M15 2v6"/><path d="M6 8h12v3a6 6 0 0 1-12 0V8Z"/><path d="M12 17v5"/>',
  dot:      '<circle cx="12" cy="12" r="7"/>',
  flame:    '<path d="M12 3c.5 3 3 4.4 3 8a3 3 0 0 1-6 0c0-1 .4-1.8.4-2.6-1.4 1-2.4 2.7-2.4 4.6a5 5 0 0 0 10 0C17.4 8.5 13.5 6.5 12 3Z"/>',
  clock:    '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
  cloud:    '<path d="M7 18h10a3.5 3.5 0 0 0 .3-7A5 5 0 0 0 7.6 9.5 3.75 3.75 0 0 0 7 18Z"/>',
  activity: '<path d="M2 12h4l2.5 7 4-15L15 12h7"/>',
  chart:    '<path d="M4 4v15a1 1 0 0 0 1 1h15"/><path d="M7 15l4-5 3 2.5L20 6"/>',
  trophy:   '<path d="M8 21h8M12 17v4"/><path d="M6 4h12v5a6 6 0 0 1-12 0V4Z"/><path d="M6 6H4a2 2 0 0 0 0 4h2M18 6h2a2 2 0 0 0 0 4h-2"/>',
  sparkle:  '<path d="M12 3l1.7 5.3L19 10l-5.3 1.7L12 17l-1.7-5.3L5 10l5.3-1.7L12 3Z"/><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8Z"/>',
  share:    '<path d="M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7"/><path d="M16 6l-4-4-4 4"/><path d="M12 2v13"/>',
  calendar: '<rect x="4" y="5" width="16" height="16" rx="2"/><path d="M4 9h16M8 3v4M16 3v4"/>',
  chevron:  '<path d="M9 6l6 6-6 6"/>',
  zap:      '<path d="M13 2L4 14h7l-1 8 9-12h-7l1-8Z"/>'
};
function icon(name, cls) {
  return '<svg class="' + (cls || '') + '" viewBox="0 0 24 24" fill="none" ' +
    'stroke="currentColor" stroke-width="1.8" stroke-linecap="round" ' +
    'stroke-linejoin="round" aria-hidden="true">' + (P[name] || P.dot) + '</svg>';
}
var FUEL_ICON = { solar:'sun', wind:'wind', hydro:'droplet', nuclear:'atom',
  biomass:'sprout', imports:'plug', other:'dot', gas:'flame', coal:'flame' };
// carbon-band status glyph, distinct SHAPE per band (not colour alone)
var STATUS_ICON = { clean:'leaf', moderate:'cloud', high:'flame' };

/* ---- Dwellow logotype (inline, recolourable) ---------------------------- */
function dwLogo(wordColor) {
  var navy = wordColor || 'rgb(36,54,68)';
  return '<svg viewBox="0 0 500 176" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Dwellow">' +
    '<g transform="matrix(1,0,0,1,106.06,21.9)" fill="' + navy + '">' +
    '<path d="M0,-5.7L3.08,4.3C3.3,5 3.92,5.4 4.61,5.4L5.09,5.4C5.69,5.4 6.23,5.06 6.5,4.52L12.11,-9.56C12.4,-10.31 11.85,-11.13 11.04,-11.13L9.21,-11.13C8.74,-11.13 8.31,-10.83 8.14,-10.39L4.82,-1.63L2.31,-10.3C2.17,-10.79 1.72,-11.13 1.21,-11.13L-1.21,-11.13C-1.72,-11.13 -2.17,-10.79 -2.31,-10.3L-4.82,-1.63L-8.14,-10.39C-8.31,-10.83 -8.74,-11.13 -9.21,-11.13L-11.04,-11.13C-11.85,-11.13 -12.4,-10.31 -12.11,-9.56L-6.5,4.52C-6.23,5.06 -5.69,5.4 -5.09,5.4L-4.61,5.4C-3.92,5.4 -3.3,5 -3.08,4.3L0,-5.7Z"/></g>' +
    '<g transform="matrix(1,0,0,1,66.44,25.7)" fill="' + navy + '"><path d="M0,-23.34L-1.86,-24.63C-2.32,-24.95 -2.95,-24.62 -2.95,-24.05L-2.95,0.36C-2.95,1.05 -2.4,1.61 -1.71,1.61L-0.41,1.61C0.28,1.61 0.84,1.05 0.84,0.36L0.84,-21.74C0.84,-22.38 0.52,-22.98 0,-23.34"/></g>' +
    '<g transform="matrix(1,0,0,1,13.4,6.73)" fill="' + navy + '"><path d="M0,14.58C-0.37,15.23 -0.86,15.74 -1.47,16.1C-2.09,16.47 -2.77,16.66 -3.53,16.66C-4.29,16.66 -4.98,16.47 -5.62,16.1C-6.25,15.74 -6.75,15.23 -7.12,14.58C-7.49,13.94 -7.67,13.2 -7.67,12.38C-7.67,11.53 -7.49,10.78 -7.12,10.14C-6.75,9.49 -6.26,8.98 -5.64,8.62C-5.01,8.25 -4.32,8.06 -3.56,8.06C-2.78,8.06 -2.08,8.25 -1.45,8.62C-0.83,8.98 -0.34,9.49 0.02,10.14C0.37,10.78 0.55,11.53 0.55,12.38C0.55,13.2 0.37,13.94 0,14.58M3.86,-4.38L1.99,-5.67C1.53,-5.99 0.9,-5.66 0.9,-5.09L0.9,6.42C0.32,5.71 -0.37,5.16 -1.19,4.75C-2.03,4.33 -3.01,4.12 -4.1,4.12C-5.1,4.12 -6.06,4.33 -6.97,4.75C-7.89,5.18 -8.7,5.76 -9.4,6.51C-10.1,7.26 -10.66,8.12 -11.06,9.12C-11.46,10.11 -11.66,11.16 -11.66,12.28C-11.66,13.44 -11.46,14.52 -11.06,15.54C-10.66,16.55 -10.1,17.43 -9.4,18.18C-8.7,18.93 -7.89,19.51 -6.97,19.94C-6.06,20.36 -5.1,20.57 -4.1,20.57C-2.98,20.57 -2,20.35 -1.15,19.92C-0.35,19.51 0.33,18.96 0.9,18.26L0.9,19.33C0.9,20.02 1.45,20.57 2.14,20.57L3.44,20.57C4.13,20.57 4.69,20.02 4.69,19.33L4.69,-1.78C4.69,-2.42 4.38,-3.02 3.86,-3.38"/></g>' +
    '<g transform="matrix(1,0,0,1,72.98,25.7)" fill="' + navy + '"><path d="M0,-23.34L-1.86,-24.63C-2.32,-24.95 -2.95,-24.62 -2.95,-24.05L-2.95,0.36C-2.95,1.05 -2.4,1.61 -1.71,1.61L-0.41,1.61C0.28,1.61 0.84,1.05 0.84,0.36L0.84,-21.74C0.84,-22.38 0.52,-22.98 0,-23.34"/></g>' +
    '<g transform="matrix(1,0,0,1,88.42,16.74)" fill="' + navy + '"><path d="M0,4.71C-0.43,5.41 -0.99,5.94 -1.67,6.3C-2.35,6.67 -3.06,6.85 -3.79,6.85C-4.53,6.85 -5.24,6.67 -5.92,6.3C-6.6,5.94 -7.15,5.41 -7.57,4.73C-7.99,4.05 -8.21,3.24 -8.21,2.31C-8.21,1.46 -8.01,0.7 -7.62,0.03C-7.23,-0.64 -6.7,-1.16 -6.03,-1.55C-5.37,-1.94 -4.63,-2.14 -3.83,-2.14C-2.96,-2.14 -2.19,-1.95 -1.5,-1.59C-0.83,-1.22 -0.3,-0.7 0.08,-0.03C0.46,0.64 0.65,1.4 0.65,2.27C0.65,3.21 0.43,4.02 0,4.71M0.48,-5C-0.79,-5.75 -2.21,-6.12 -3.79,-6.12C-4.95,-6.12 -6.04,-5.9 -7.05,-5.47C-8.06,-5.03 -8.96,-4.42 -9.74,-3.64C-10.52,-2.86 -11.13,-1.96 -11.56,-0.93C-11.99,0.09 -12.21,1.19 -12.21,2.37C-12.21,3.6 -11.98,4.73 -11.51,5.76C-11.05,6.79 -10.41,7.68 -9.6,8.44C-8.79,9.19 -7.87,9.77 -6.84,10.2C-5.82,10.62 -4.78,10.83 -3.73,10.83C-2.68,10.83 -1.65,10.63 -0.65,10.23C0.35,9.83 1.25,9.25 2.06,8.51C2.86,7.76 3.49,6.87 3.96,5.82C4.43,4.78 4.66,3.62 4.66,2.34C4.66,0.74 4.28,-0.7 3.53,-1.97C2.77,-3.24 1.76,-4.25 0.48,-5"/></g>' +
    '<g transform="matrix(1,0,0,1,84.37,32.5)" fill="rgb(54,179,152)"><path d="M0,-2.25C0.09,-1.98 0,-1.68 -0.21,-1.5C-3.12,0.92 -8.68,4.34 -16.13,3.43C-23.63,2.52 -28.62,-2.24 -31.13,-5.32C-31.3,-5.53 -31.34,-5.82 -31.23,-6.06C-31.05,-6.46 -30.56,-6.59 -30.2,-6.35C-25.14,-2.98 -13.87,2.68 -0.96,-2.73C-0.58,-2.89 -0.14,-2.7 -0.01,-2.3L0,-2.25Z"/></g>' +
    '</svg>';
}

/* ---- little formatting helpers ------------------------------------------ */
var CAP = function (s) { return s.charAt(0).toUpperCase() + s.slice(1); };
var pct = function (n) { return Math.round(n); };

/* =========================================================================
   SVG CHART BUILDERS, each takes a pixel width and returns an <svg> string.
   ========================================================================= */
function pts2str(a) { return a.map(function (p) { return p[0].toFixed(1) + ',' + p[1].toFixed(1); }).join(' '); }

/* build a stroke path in one of three treatments: crisp segments (default),
   soft curves (Catmull-Rom → bezier), or stepped (honest to half-hourly data) */
function linePath(pts, style) {
  if (!pts.length) return '';
  var d = 'M' + pts[0][0].toFixed(1) + ',' + pts[0][1].toFixed(1), i;
  if (style === 'stepped') {
    for (i = 1; i < pts.length; i++) d += ' H' + pts[i][0].toFixed(1) + ' V' + pts[i][1].toFixed(1);
  } else if (style === 'smooth') {
    for (i = 0; i < pts.length - 1; i++) {
      var p0 = pts[i - 1] || pts[i], p1 = pts[i], p2 = pts[i + 1], p3 = pts[i + 2] || p2;
      var c1x = p1[0] + (p2[0] - p0[0]) / 6, c1y = p1[1] + (p2[1] - p0[1]) / 6;
      var c2x = p2[0] - (p3[0] - p1[0]) / 6, c2y = p2[1] - (p3[1] - p1[1]) / 6;
      d += ' C' + c1x.toFixed(1) + ',' + c1y.toFixed(1) + ' ' + c2x.toFixed(1) + ',' + c2y.toFixed(1) + ' ' + p2[0].toFixed(1) + ',' + p2[1].toFixed(1);
    }
  } else {
    for (i = 1; i < pts.length; i++) d += ' L' + pts[i][0].toFixed(1) + ',' + pts[i][1].toFixed(1);
  }
  return d;
}

/* 24-hour carbon line: bands behind, solid history, dashed forecast, 'now'. */
function chartCarbon(w, opts) {
  var ls = (opts && opts.lineStyle) || 'segments';
  var h = 150, padL = 8, padR = 34, padT = 16, padB = 20;
  var x0 = padL, x1 = w - padR, y0 = padT, y1 = h - padB;
  var gMin = 80, gMax = 230, nowH = D.now.nowHour;
  var xFor = function (hr) { return x0 + (hr / 24) * (x1 - x0); };
  var yFor = function (g) { return y1 - ((g - gMin) / (gMax - gMin)) * (y1 - y0); };
  var interp = function (hr) { var lo = Math.floor(hr), t = hr - lo; return D.now.carbon24[lo].g + t * (D.now.carbon24[lo + 1].g - D.now.carbon24[lo].g); };

  // band zones
  var zones =
    '<rect x="' + x0 + '" y="' + yFor(130).toFixed(1) + '" width="' + (x1 - x0).toFixed(1) + '" height="' + (y1 - yFor(130)).toFixed(1) + '" class="dw-zone--clean"/>' +
    '<rect x="' + x0 + '" y="' + yFor(210).toFixed(1) + '" width="' + (x1 - x0).toFixed(1) + '" height="' + (yFor(130) - yFor(210)).toFixed(1) + '" class="dw-zone--moderate"/>' +
    '<rect x="' + x0 + '" y="' + y0 + '" width="' + (x1 - x0).toFixed(1) + '" height="' + (yFor(210) - y0).toFixed(1) + '" class="dw-zone--high"/>';
  var zoneLabels =
    '<text x="' + (x1 + 4) + '" y="' + (yFor(220)).toFixed(1) + '" class="dw-zone-label" fill="var(--dw-high)">high</text>' +
    '<text x="' + (x1 + 4) + '" y="' + (yFor(170)).toFixed(1) + '" class="dw-zone-label" fill="var(--dw-moderate)">avg</text>' +
    '<text x="' + (x1 + 4) + '" y="' + (yFor(105)).toFixed(1) + '" class="dw-zone-label" fill="var(--dw-clean)">clean</text>';

  var all = D.now.carbon24.map(function (d) { return [xFor(d.h), yFor(d.g)]; });
  var nowPt = [xFor(nowH), yFor(interp(nowH))];
  var solid = all.filter(function (_, i) { return i <= nowH; }).concat([nowPt]);
  var dash = [nowPt].concat(all.filter(function (_, i) { return i > nowH; }));
  var area = pts2str(solid) + ' ' + (x1).toFixed(1) + ',' + y1 + ' ' + x0 + ',' + y1;

  var xl =
    '<text x="' + x0 + '" y="' + (h - 5) + '" class="dw-axis">12am</text>' +
    '<text x="' + xFor(12).toFixed(1) + '" y="' + (h - 5) + '" class="dw-axis" text-anchor="middle">noon</text>' +
    '<text x="' + (x1).toFixed(1) + '" y="' + (h - 5) + '" class="dw-axis" text-anchor="end">12am</text>';

  return '<svg class="dw-chart" viewBox="0 0 ' + w + ' ' + h + '" width="' + w + '" height="' + h + '" role="img" aria-label="Carbon intensity through the day: lower is cleaner. The solid line is today so far; the dashed line is the forecast ahead.">' +
    zones + zoneLabels +
    '<polygon points="' + area + '" class="dw-line-fill"/>' +
    '<path d="' + linePath(solid, ls) + '" class="dw-line"/>' +
    '<path d="' + linePath(dash, ls) + '" class="dw-line dw-line--forecast"/>' +
    '<line x1="' + nowPt[0].toFixed(1) + '" y1="' + y0 + '" x2="' + nowPt[0].toFixed(1) + '" y2="' + y1 + '" class="dw-now-line"/>' +
    '<circle cx="' + nowPt[0].toFixed(1) + '" cy="' + nowPt[1].toFixed(1) + '" r="4" class="dw-now-dot"/>' +
    '<text x="' + nowPt[0].toFixed(1) + '" y="' + (nowPt[1] - 9).toFixed(1) + '" class="dw-now-flag" text-anchor="middle">now</text>' +
    xl + '</svg>';
}

/* Multi-year greening: clean area (bottom) vs fossil (top), to 100%. */
function chartGreening(w, opts) {
  var ls = (opts && opts.lineStyle) || 'segments';
  var h = 152, padL = 8, padR = 8, padT = 22, padB = 20;
  var x0 = padL, x1 = w - padR, y0 = padT, y1 = h - padB;
  var g = D.trends.greening, n = g.length;
  var xFor = function (i) { return x0 + (i / (n - 1)) * (x1 - x0); };
  var yFor = function (p) { return y1 - (p / 100) * (y1 - y0); };
  var cleanTop = g.map(function (d, i) { return [xFor(i), yFor(d.clean)]; });
  var cleanArea = pts2str(cleanTop) + ' ' + x1.toFixed(1) + ',' + y1 + ' ' + x0 + ',' + y1;
  var fossilArea = pts2str(cleanTop) + ' ' + x1.toFixed(1) + ',' + y0 + ' ' + x0 + ',' + y0;
  // crossover (first year clean >= 50%) — label uses the real year, not a fixed one
  var ci = g.findIndex(function (d) { return d.clean >= 50; });
  var cross = '';
  if (ci > 0) {
    var cx = xFor(ci), cy = yFor(g[ci].clean);
    cross = '<circle cx="' + cx.toFixed(1) + '" cy="' + cy.toFixed(1) + '" r="3.5" fill="var(--dw-bg)" stroke="#2f8f6f" stroke-width="2"/>' +
      '<text x="' + cx.toFixed(1) + '" y="' + (cy - 8).toFixed(1) + '" class="dw-endcap" fill="var(--dw-ink)" text-anchor="middle">50 / 50 · ’' + String(g[ci].y).slice(-2) + '</text>';
  }
  return '<svg class="dw-chart" viewBox="0 0 ' + w + ' ' + h + '" width="' + w + '" height="' + h + '" role="img" aria-label="The greening of the grid: clean sources grew from about ' + g[0].clean + '% of Britain\'s power in ' + g[0].y + ' to around ' + g[n - 1].clean + '% now, while fossil fuels shrank.">' +
    '<polygon points="' + fossilArea + '" class="dw-area-fossil"/>' +
    '<polygon points="' + cleanArea + '" class="dw-area-clean"/>' +
    '<path d="' + linePath(cleanTop, ls) + '" class="dw-area-line dw-area-line--clean"/>' +
    '<text x="' + (x0 + 3) + '" y="' + (yFor(12)).toFixed(1) + '" class="dw-endcap" fill="#fff">clean</text>' +
    '<text x="' + (x0 + 3) + '" y="' + (yFor(88)).toFixed(1) + '" class="dw-endcap" fill="var(--dw-ink-2)">the rest</text>' +
    cross +
    '<text x="' + x0 + '" y="' + (h - 5) + '" class="dw-axis">' + g[0].y + '</text>' +
    '<text x="' + x1.toFixed(1) + '" y="' + (h - 5) + '" class="dw-axis" text-anchor="end">now</text>' +
    '</svg>';
}

/* Carbon by year: line falling to a 2024 low, bands behind. */
function chartYear(w, opts) {
  var ls = (opts && opts.lineStyle) || 'segments';
  var h = 140, padL = 8, padR = 8, padT = 18, padB = 20;
  var x0 = padL, x1 = w - padR, y0 = padT, y1 = h - padB;
  var yr = D.trends.yearCarbon, n = yr.length, gMin = 80, gMax = 520;
  var xFor = function (i) { return x0 + (i / (n - 1)) * (x1 - x0); };
  var yFor = function (v) { return y1 - ((v - gMin) / (gMax - gMin)) * (y1 - y0); };
  var line = yr.map(function (d, i) { return [xFor(i), yFor(d.g)]; });
  var area = pts2str(line) + ' ' + x1.toFixed(1) + ',' + y1 + ' ' + x0 + ',' + y1;
  // 2024 low
  var li = yr.reduce(function (m, d, i) { return d.g < yr[m].g ? i : m; }, 0);
  var lx = xFor(li), ly = yFor(yr[li].g);
  var bands =
    '<rect x="' + x0 + '" y="' + yFor(130).toFixed(1) + '" width="' + (x1 - x0).toFixed(1) + '" height="' + (y1 - yFor(130)).toFixed(1) + '" class="dw-zone--clean"/>' +
    '<rect x="' + x0 + '" y="' + yFor(300).toFixed(1) + '" width="' + (x1 - x0).toFixed(1) + '" height="' + (yFor(130) - yFor(300)).toFixed(1) + '" class="dw-zone--moderate"/>' +
    '<rect x="' + x0 + '" y="' + y0 + '" width="' + (x1 - x0).toFixed(1) + '" height="' + (yFor(300) - y0).toFixed(1) + '" class="dw-zone--high"/>';
  var startG = yr[0].g, nowG = yr[n - 1].g, ratio = Math.max(2, Math.round(startG / (nowG || 1)));
  return '<svg class="dw-chart" viewBox="0 0 ' + w + ' ' + h + '" width="' + w + '" height="' + h + '" role="img" aria-label="Average carbon a year has fallen from about ' + startG + ' in ' + yr[0].y + ' to around ' + nowG + ' now, reaching its lowest in ' + yr[li].y + '.">' +
    bands +
    '<polygon points="' + area + '" class="dw-line-fill"/>' +
    '<path d="' + linePath(line, ls) + '" class="dw-line" style="stroke:#2f6f63"/>' +
    '<circle cx="' + lx.toFixed(1) + '" cy="' + ly.toFixed(1) + '" r="4" fill="var(--dw-clean)" stroke="var(--dw-bg)" stroke-width="2.5"/>' +
    '<text x="' + lx.toFixed(1) + '" y="' + (ly + 15).toFixed(1) + '" class="dw-endcap" fill="var(--dw-clean-ink)" text-anchor="middle">cleanest yet</text>' +
    '<text x="' + (x0) + '" y="' + (yFor(Math.min(gMax - 12, startG)) - 6).toFixed(1) + '" class="dw-endcap" fill="var(--dw-high)">≈' + ratio + '× today</text>' +
    '<text x="' + x0 + '" y="' + (h - 5) + '" class="dw-axis">' + yr[0].y + '</text>' +
    '<text x="' + x1.toFixed(1) + '" y="' + (h - 5) + '" class="dw-axis" text-anchor="end">now</text>' +
    '</svg>';
}

/* horizontal mini stacked bar (for on-this-day) */
function miniMix(mix) {
  return '<div class="dw-mixbar" style="height:22px">' + mix.map(function (f) {
    return '<span class="dw-mixbar__seg dw-fuel-' + f.id + '" style="width:' + f.pct + '%" title="' + f.name + ' ' + f.pct + '%"></span>';
  }).join('') + '</div>';
}

/* =========================================================================
   VIEW RENDERERS
   ========================================================================= */
function bandChipWord(b) { return b === 'clean' ? 'Clean' : b === 'high' ? 'High' : 'Moderate'; }

function renderNow() {
  var n = D.now;
  // gauge marker position from intensity (hidden number)
  var gpos = Math.max(4, Math.min(96, ((n.gaugeG != null ? n.gaugeG : 136) - 45) / (300 - 45) * 100));
  // legend + mix segments, grouped clean | fossil
  var lastClean = null;
  n.mix.forEach(function (f) { if (f.group === 'clean') lastClean = f.id; });
  var segs = n.mix.filter(function (f) { return f.pct > 0; }).map(function (f) {
    return '<span class="dw-mixbar__seg dw-fuel-' + f.id + '"' + (f.id === lastClean ? ' data-group-end' : '') +
      ' style="width:' + f.pct + '%" title="' + f.name + ' ' + f.pct + '%"></span>';
  }).join('');
  var legend = n.mix.map(function (f) {
    return '<li class="dw-legend__item"' + (f.pct === 0 ? ' data-zero' : '') + '>' +
      '<span class="dw-legend__swatch dw-fuel-' + f.id + '"></span>' +
      '<span class="dw-legend__name">' + f.name + '</span>' +
      '<span class="dw-legend__pct">' + f.pct + '%</span></li>';
  }).join('');
  var engNums = n.mix.map(function (f) { return f.name + ' <span>' + f._eng + '</span>'; }).join(' · ');

  return '' +
  '<div class="dw-stack">' +
    '<div class="dw-hero">' +
      '<div class="dw-hero__row">' +
        '<div class="dw-hero__text">' +
          '<h2 class="dw-hero__headline">' + n.headline + '</h2>' +
          '<p class="dw-hero__sub">' + n.subline + '</p>' +
        '</div>' +
        '<div class="dw-status" data-band="' + n.band + '">' +
          '<span class="dw-status__dot">' + icon(STATUS_ICON[n.band] || 'cloud') + '</span>' +
          '<span class="dw-status__word">' + n.statusWord + '</span>' +
        '</div>' +
      '</div>' +
      '<div class="dw-gauge" aria-hidden="true">' +
        '<div class="dw-gauge__track"><span class="dw-gauge__marker" style="left:' + gpos.toFixed(1) + '%"></span></div>' +
        '<div class="dw-gauge__scale"><span>Cleaner</span><span>Average</span><span>Higher</span></div>' +
      '</div>' +
    '</div>' +

    '<div class="dw-forecast">' +
      '<span class="dw-forecast__icon">' + icon('clock') + '</span>' +
      '<div class="dw-forecast__text">' +
        '<div class="dw-forecast__lead">Greenest window ahead: <b>' + n.greenWindow.fromLabel + ' – ' + n.greenWindow.toLabel + '</b></div>' +
        '<div class="dw-forecast__sub">' + n.greenWindow.action + '</div>' +
      '</div>' +
    '</div>' +

    '<div class="dw-now-2col">' +
      '<div class="dw-mix">' +
        '<div class="dw-sec__head"><h3 class="dw-sec__title">Where your power’s coming from</h3></div>' +
        '<div class="dw-mixbar">' + segs + '</div>' +
        '<p class="dw-mix__caption">' + n.mixCaption + '</p>' +
        '<ul class="dw-legend">' + legend + '</ul>' +
      '</div>' +
      '<div class="dw-mix">' +
        '<div class="dw-sec__head"><h3 class="dw-sec__title">Through the day</h3><span class="dw-sec__note">forecast dashed</span></div>' +
        '<div class="dw-chart-slot" data-chart="carbon"></div>' +
        '<div class="dw-chart__foot">' + (n.dayLowLabel ? '<span>Cleanest around ' + n.dayLowLabel + '</span><span>Highest around ' + n.dayHighLabel + '</span>' : '<span>Lower is cleaner</span><span>Forecast dashed ahead</span>') + '</div>' +
      '</div>' +
    '</div>' +

    '<details class="dw-nums"><summary>' + icon('chevron') + 'Show the numbers</summary>' +
      '<div class="dw-nums__body">Carbon right now <span>' + n._engIntensity + '</span> · ' + engNums + '</div>' +
    '</details>' +
  '</div>';
}

// [dwellow-integration] the "on this day" card, factored so its comparison year
// can be cycled in place (wireOnThisDay). Reads the current selection from D.
function onThisDayInner() {
  var o = D.trends.onThisDay;
  var thenRow = o.then, nowRow = o.now;
  var canCycle = o.thenOptions && o.thenOptions.length > 1;
  return '' +
    '<div class="dw-sec__head">' +
      '<h3 class="dw-sec__title">On this day' + (o.dateLabel ? ' <span class="dw-otd__date">' + o.dateLabel + '</span>' : '') + '</h3>' +
      (canCycle
        ? '<button class="dw-date-pick" type="button" data-otd-cycle aria-label="Compare with a different year">vs ' + thenRow.year + ' ' + icon('chevron') + '</button>'
        : '') +
    '</div>' +
    '<div class="dw-otd__row">' +
      '<div class="dw-otd__label"><span class="dw-otd__year">' + thenRow.year + '</span><span class="dw-otd__tag">carbon: ' + thenRow.band + '</span></div>' +
      miniMix(thenRow.mix) +
    '</div>' +
    '<div class="dw-otd__row">' +
      '<div class="dw-otd__label"><span class="dw-otd__year">' + nowRow.year + ' · this year</span><span class="dw-otd__tag">carbon: ' + nowRow.band + '</span></div>' +
      miniMix(nowRow.mix) +
    '</div>' +
    '<p class="dw-otd__verdict">' + o.verdict + '</p>';
}

function renderTrends() {
  var t = D.trends;
  return '' +
  '<div class="dw-stack">' +
    '<div class="dw-mix">' +
      '<div class="dw-sec__head"><h3 class="dw-sec__title">The greening of the grid</h3><span class="dw-sec__note">2009 → now</span></div>' +
      '<div class="dw-chart-slot" data-chart="greening"></div>' +
      '<div class="dw-legend-inline">' +
        '<span class="dw-chip"><span class="dw-chip__dot" style="background:var(--dw-accent-2)"></span>Clean sources</span>' +
        '<span class="dw-chip"><span class="dw-chip__dot" style="background:var(--dw-fuel-coal);opacity:.55"></span>Gas, coal &amp; imports</span>' +
      '</div>' +
      '<p class="dw-mix__caption" style="margin-top:8px">' + t.greeningCaption + '</p>' +
    '</div>' +

    '<div class="dw-mix">' +
      '<div class="dw-sec__head"><h3 class="dw-sec__title">Getting cleaner every year</h3></div>' +
      '<div class="dw-chart-slot" data-chart="year"></div>' +
      '<p class="dw-mix__caption" style="margin-top:8px">' + t.yearCaption + '</p>' +
    '</div>' +

    '<div class="dw-card dw-card--inset dw-otd">' + onThisDayInner() + '</div>' +

    '<details class="dw-nums"><summary>' + icon('chevron') + 'Show the numbers</summary>' +
      '<div class="dw-nums__body">' + t.numsBody + '</div>' +
    '</details>' +
  '</div>';
}

function renderRecords(inst) {
  var r = D.records;
  var cards = r.list.map(function (rec) {
    return '<article class="dw-rec">' +
      '<div class="dw-rec__top">' +
        '<span class="dw-rec__icon">' + icon(rec.icon) + '</span>' +
        '<div style="min-width:0"><h4 class="dw-rec__title">' + rec.title + '</h4>' +
          '<div class="dw-rec__date">' + rec.dateLabel + '</div></div>' +
        '<button class="dw-rec__share" type="button" data-share="' + rec.id + '" aria-label="Share ‘' + rec.title + '’">' + icon('share') + '</button>' +
      '</div>' +
      '<p class="dw-rec__caption">' + rec.caption + '</p>' +
      '<div class="dw-prog">' +
        '<div class="dw-prog__track"><span class="dw-prog__fill" style="width:' + pct(rec.nowFrac * 100) + '%"></span></div>' +
        '<div class="dw-prog__meta"><span>right now vs the record</span><b>' + rec.offCopy + '</b></div>' +
      '</div>' +
    '</article>';
  }).join('');

  var engNums = r.list.map(function (rec) { return rec.title.replace('Most ', '').replace('Cleanest ', 'cleanest ') + ' <span>' + rec._eng + '</span>'; }).join(' · ');

  return '' +
  '<div class="dw-stack">' +
    '<div class="dw-coal">' +
      '<svg class="dw-coal__rays" viewBox="0 0 100 60" preserveAspectRatio="xMidYMin slice" aria-hidden="true">' +
        raysSVG() + '</svg>' +
      '<div style="position:relative">' +
        '<div class="dw-coal__kicker">Days &amp; counting</div>' +
        '<span class="dw-coal__num" data-count="' + r.coal.days + '">' + r.coal.days + '</span>' +
        '<div class="dw-coal__unit">days ' + r.coal.sinceLabel + '</div>' +
        '<div class="dw-coal__sub">The last coal power station closed for good, and Britain hasn’t looked back.</div>' +
      '</div>' +
    '</div>' +

    '<div class="dw-sec__head"><h3 class="dw-sec__title">The record wall</h3><span class="dw-sec__note">tap ' + icon('share') + ' to share</span></div>' +
    '<div class="dw-wall">' + cards + '</div>' +

    '<details class="dw-nums"><summary>' + icon('chevron') + 'Show the numbers</summary>' +
      '<div class="dw-nums__body">' + engNums + '</div>' +
    '</details>' +

    '<div class="dw-share-wrap" data-share-overlay>' +
      '<div class="dw-share-panel">' + // [dwellow-integration] actions sit BELOW the fixed-ratio card so they never clip
        '<div class="dw-share-card" data-share-card>' +
          '<div class="dw-share-card__label" data-share-label>Britain’s cleanest half-hour</div>' +
          '<div class="dw-share-card__big" data-share-big>The greenest the grid has ever been.</div>' +
          '<div class="dw-share-card__foot">' +
            '<span class="dw-share-card__logo">' + dwLogo('#ffffff') + '</span>' +
            '<span style="font-size:11px;opacity:.85">dwellow.co.uk</span>' +
          '</div>' +
        '</div>' +
        '<div class="dw-share-actions">' +
          '<button class="dw-btn dw-btn--primary" type="button" data-share-do>' + icon('share') + 'Share</button>' +
          '<button class="dw-btn dw-btn--ghost" type="button" data-share-copy>Copy text</button>' +
          '<button class="dw-btn dw-btn--ghost" type="button" data-share-close>Close</button>' +
        '</div>' +
      '</div>' +
    '</div>' +
  '</div>';
}

function raysSVG() {
  var out = '', cx = 50, cy = -6;
  for (var i = 0; i < 11; i++) {
    var a = (-90 + (i - 5) * 15) * Math.PI / 180;
    var x = cx + Math.cos(a) * 90, y = cy + Math.sin(a) * 90;
    out += '<line x1="' + cx + '" y1="' + cy + '" x2="' + x.toFixed(1) + '" y2="' + y.toFixed(1) + '" stroke="rgba(255,255,255,0.09)" stroke-width="3"/>';
  }
  return out;
}

/* =========================================================================
   MOUNT + WIRING
   ========================================================================= */
var TABS = [
  { id: 'now',     label: 'Now',     icon: 'zap',    render: renderNow },
  { id: 'trends',  label: 'Trends',  icon: 'chart',  render: renderTrends },
  { id: 'records', label: 'Records', icon: 'trophy', render: renderRecords }
];

function mount(el, opts) {
  opts = opts || {};
  if (opts.data) D = opts.data; // [dwellow-integration] live data via opts instead of a fixed global
  var dir = opts.direction || 'warm';
  var active = opts.view || 'now';
  var id = 'dw' + (++uid);

  el.className = 'dw-grid';
  el.setAttribute('data-direction', dir);
  el.setAttribute('lang', 'en-GB');

  var tabsHTML = TABS.map(function (t) {
    var sel = t.id === active;
    return '<button class="dw-tab" role="tab" id="' + id + '-tab-' + t.id + '" ' +
      'aria-controls="' + id + '-panel-' + t.id + '" aria-selected="' + sel + '" ' +
      'tabindex="' + (sel ? '0' : '-1') + '">' + icon(t.icon) + '<span>' + t.label + '</span></button>';
  }).join('');

  var panelsHTML = TABS.map(function (t) {
    var sel = t.id === active;
    return '<section class="dw-panel" role="tabpanel" id="' + id + '-panel-' + t.id + '" ' +
      'aria-labelledby="' + id + '-tab-' + t.id + '" tabindex="0"' + (sel ? ' data-active' : '') +
      (sel ? '' : ' hidden') + '>' + t.render() + '</section>';
  }).join('');

  el.innerHTML =
    '<div class="dw-head">' +
      '<div class="dw-head__title">' +
        '<span class="dw-head__mark">' + icon('zap') + '</span>' +
        '<span class="dw-head__label">' +
          '<span class="dw-head__kicker">Britain’s electricity</span>' +
          '<span class="dw-head__name">Live from the grid</span>' +
        '</span>' +
      '</div>' +
      '<span class="dw-head__updated"><span class="dw-live-dot"></span>' + D.now.updatedLabel + '</span>' +
    '</div>' +
    '<div class="dw-tabs" role="tablist" aria-label="Grid views">' + tabsHTML + '</div>' +
    '<div class="dw-tabs-underline"></div>' +
    '<div class="dw-body">' + panelsHTML + '</div>';

  var tip = makeTip(el); // [dwellow-integration]
  wireTabs(el, id);
  wireShare(el);
  wireMixTips(el, tip);   // [dwellow-integration] fuel + % on tap/hover
  wireChartTips(el, tip); // [dwellow-integration] year + figures on the trend charts
  wireOnThisDay(el, tip); // [dwellow-integration] cycle the comparison year
  drawCharts(el);
  observe(el);
  animateCount(el);
  return el;
}

function wireTabs(el, id) {
  var tabs = Array.prototype.slice.call(el.querySelectorAll('.dw-tab'));
  function select(idx, focus) {
    tabs.forEach(function (tb, i) {
      var on = i === idx;
      tb.setAttribute('aria-selected', on);
      tb.tabIndex = on ? 0 : -1;
      var panel = el.querySelector('#' + tb.getAttribute('aria-controls'));
      if (on) { panel.setAttribute('data-active', ''); panel.hidden = false; }
      else { panel.removeAttribute('data-active'); panel.hidden = true; }
      if (on && focus) tb.focus();
    });
    drawCharts(el); animateCount(el);   // synchronous, rAF is paused off-screen
  }
  tabs.forEach(function (tb, i) {
    tb.addEventListener('click', function () { select(i, false); });
    tb.addEventListener('keydown', function (e) {
      var k = e.key, ni = null;
      if (k === 'ArrowRight' || k === 'ArrowDown') ni = (i + 1) % tabs.length;
      else if (k === 'ArrowLeft' || k === 'ArrowUp') ni = (i - 1 + tabs.length) % tabs.length;
      else if (k === 'Home') ni = 0; else if (k === 'End') ni = tabs.length - 1;
      if (ni !== null) { e.preventDefault(); select(ni, true); }
    });
  });
}

// [dwellow-integration] real sharing: the native share sheet where available,
// otherwise copy the line + link to the clipboard.
function wireShare(el) {
  var overlay = el.querySelector('[data-share-overlay]');
  if (!overlay) return;
  var label = overlay.querySelector('[data-share-label]');
  var big = overlay.querySelector('[data-share-big]');
  var current = null;

  function shareUrl() { return (D && D.shareUrl) || 'https://www.dwellow.co.uk'; }
  function shareText(rec) { return rec.title + ': ' + rec.caption; }
  function flash(btn, msg) {
    var prev = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', prev);
    btn.textContent = msg; btn.disabled = true;
    setTimeout(function () { btn.textContent = prev; btn.disabled = false; }, 1600);
  }
  function copyText(text, btn) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function () { flash(btn, 'Copied'); }, function () { flash(btn, 'Copy failed'); });
    } else {
      try {
        var ta = document.createElement('textarea');
        ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.focus(); ta.select();
        document.execCommand('copy'); document.body.removeChild(ta);
        flash(btn, 'Copied');
      } catch (e) { flash(btn, 'Copy failed'); }
    }
  }

  el.querySelectorAll('[data-share]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      current = D.records.list.filter(function (r) { return r.id === btn.getAttribute('data-share'); })[0];
      if (!current) return;
      label.textContent = current.title;
      big.textContent = current.caption;
      overlay.setAttribute('data-open', '');
    });
  });
  var doBtn = overlay.querySelector('[data-share-do]');
  if (doBtn) doBtn.addEventListener('click', function () {
    if (!current) return;
    var text = shareText(current), url = shareUrl();
    if (navigator.share) {
      navigator.share({ title: current.title, text: text, url: url }).catch(function () {});
    } else {
      copyText(text + ' ' + url, doBtn);
    }
  });
  var copyBtn = overlay.querySelector('[data-share-copy]');
  if (copyBtn) copyBtn.addEventListener('click', function () {
    if (current) copyText(shareText(current) + ' ' + shareUrl(), copyBtn);
  });
  overlay.querySelectorAll('[data-share-close]').forEach(function (b) {
    b.addEventListener('click', function () { overlay.removeAttribute('data-open'); });
  });
  overlay.addEventListener('click', function (e) { if (e.target === overlay) overlay.removeAttribute('data-open'); });
}

/* [dwellow-integration] a lightweight tooltip for the mix bars and trend charts,
   so tapping/hovering reveals the fuel + % (mix bars) or the year + figures
   (greening / carbon-by-year) even though those have no permanent legend. */
function makeTip(el) {
  // append to <body>, not the widget: the widget's container-type would trap a
  // position:fixed child. Drop any previous tip so re-mounts don't accumulate.
  var prev = document.querySelector('body > .dw-tip');
  if (prev) prev.remove();
  var tip = document.createElement('div');
  tip.className = 'dw-tip';
  tip.hidden = true;
  document.body.appendChild(tip);
  return tip;
}
function showTip(tip, ev, html) {
  tip.innerHTML = html;
  tip.hidden = false;
  var x = ev.clientX, y = ev.clientY;
  var touch = ev.pointerType === 'touch' || (ev.touches && ev.touches.length);
  if ((x == null || (x === 0 && y === 0)) && ev.touches && ev.touches[0]) { x = ev.touches[0].clientX; y = ev.touches[0].clientY; }
  tip.style.left = x + 'px';
  // On touch, lift the tip well clear of the finger; snug above the cursor for mouse.
  tip.style.top = (y - (touch ? 48 : 12)) + 'px';
  if (touch) { clearTimeout(tip._t); tip._t = setTimeout(function () { tip.hidden = true; }, 2600); }
}
function hideTip(tip) { tip.hidden = true; }

function wireMixTips(root, tip) {
  root.querySelectorAll('.dw-mixbar__seg').forEach(function (seg) {
    var label = seg.getAttribute('title');
    if (!label) return;
    seg.removeAttribute('title'); // use our tooltip instead of the native one
    var show = function (ev) { showTip(tip, ev, label.replace(/(\d+%)/, '<b>$1</b>')); };
    seg.addEventListener('pointerenter', show);
    seg.addEventListener('pointermove', show);
    seg.addEventListener('pointerdown', show);
    seg.addEventListener('pointerleave', function () { hideTip(tip); });
  });
}

function wireChartTips(el, tip) {
  ['greening', 'year'].forEach(function (kind) {
    var slot = el.querySelector('.dw-chart-slot[data-chart="' + kind + '"]');
    if (!slot) return;
    function move(ev) {
      if (!slot.querySelector('svg')) return;
      var r = slot.getBoundingClientRect();
      var cx = ev.clientX; if (cx == null && ev.touches && ev.touches[0]) cx = ev.touches[0].clientX;
      var data = kind === 'greening' ? D.trends.greening : D.trends.yearCarbon;
      var n = data.length; if (!n) return;
      var x0 = 8, x1 = r.width - 8;
      var frac = Math.max(0, Math.min(1, (cx - r.left - x0) / (x1 - x0)));
      var d = data[Math.round(frac * (n - 1))];
      showTip(tip, ev, kind === 'greening'
        ? '<b>' + d.y + '</b> ' + d.clean + '% clean, ' + (100 - d.clean) + '% gas, coal &amp; imports'
        : '<b>' + d.y + '</b> ' + d.g + ' g/kWh');
    }
    slot.addEventListener('pointermove', move);
    slot.addEventListener('pointerdown', move);
    slot.addEventListener('pointerleave', function () { hideTip(tip); });
  });
}

function wireOnThisDay(el, tip) {
  var o = D.trends.onThisDay;
  var card = el.querySelector('.dw-otd');
  if (!card || !o.thenOptions || o.thenOptions.length < 2) return;
  function attach() {
    var btn = card.querySelector('[data-otd-cycle]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      o.thenIndex = (o.thenIndex + 1) % o.thenOptions.length;
      o.then = o.thenOptions[o.thenIndex];
      o.verdict = o.then.verdict;
      card.innerHTML = onThisDayInner();
      attach();
      wireMixTips(card, tip);
    });
  }
  attach();
}

var BUILDERS = { carbon: chartCarbon, greening: chartGreening, year: chartYear };
function drawCharts(el) {
  var dir = el.getAttribute('data-direction') || 'warm';
  var attr = el.getAttribute('data-lines');
  var byDir = { warm: 'smooth', compact: 'segments', playful: 'smooth' };
  var ls = (attr && attr !== '') ? attr : (byDir[dir] || 'segments');
  el.querySelectorAll('.dw-chart-slot').forEach(function (slot) {
    // skip slots in hidden panels, measuring them gives 0 and scales the SVG wrong
    if (slot.offsetParent === null) return;
    var kind = slot.getAttribute('data-chart');
    var w = Math.round(slot.getBoundingClientRect().width);
    if (!w) return;
    slot.innerHTML = BUILDERS[kind](Math.max(220, w), { lineStyle: ls });
  });
}

function observe(el) {
  if (!window.ResizeObserver) return;
  var t;
  var ro = new ResizeObserver(function () {
    clearTimeout(t); t = setTimeout(function () { drawCharts(el); }, 120);
  });
  ro.observe(el);
}

function animateCount(el) {
  var node = el.querySelector('[data-count]');
  if (!node) return;
  var target = parseInt(node.getAttribute('data-count'), 10);
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    node.textContent = target.toLocaleString('en-GB'); return;
  }
  var start = Math.max(0, target - 40), t0 = null, dur = 1100;
  function step(ts) {
    if (!t0) t0 = ts;
    var p = Math.min(1, (ts - t0) / dur);
    var e = 1 - Math.pow(1 - p, 3);
    node.textContent = Math.round(start + (target - start) * e).toLocaleString('en-GB');
    if (p < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

// [dwellow-integration] was: window.DwellowGrid = {...}; })(); , now an ES export + settable data.
export const DwellowGrid = {
  mount: mount,
  draw: drawCharts,
  icon: icon,
  dwLogo: dwLogo,
  setData: function (d) { D = d; },
  render: { now: renderNow, trends: renderTrends, records: renderRecords }
};
